import React, {ReactElement} from "react"
import TitleBar from "../../components/TitleBar/TitleBar"
import {MainSectionTable} from "../../containers/MainSection/MainSection"
import ManagedSolutionsAccountsTable from "../../components/ManagedSolutionsAccounts/ManagedSolutionsAccountsTable"
import {usePaging} from "../../hooks/usePaging"
import {useAccessToken} from "../../services/auth"
import {findManagedSolutionsAccounts, exportManagedSolutionsAccounts} from "../../resources/managedSolutions"
import {AsyncResultComponent} from "../../containers/AsyncResult/AsyncResult"
import {DataTableActionHeader, DataTableCard, TablePending} from "../../components/DataTable/DataTable"
import {ManagedSolutionsAccountsColumns} from "../../components/ManagedSolutionsAccounts/ManagedSolutionsAccounts.types"
import {downloadFile} from "../../utilities/file"
import {useToasts} from "react-toast-notifications"

export function ManagedSolutionsOrgAccountsPage(): ReactElement {
	const accessToken = useAccessToken()
	const {addToast} = useToasts()
	const limit = 40

	const [result, hasPrev, hasNext, prev, next, hasResults] = usePaging(
		limit,
		(offset, limit) =>
			findManagedSolutionsAccounts(accessToken, offset, limit, undefined, {purpose: "operational_account"}),
		(x) => x.data.length,
		[],
		"rtl-org-acc",
		true
	)

	async function exportOrgAccounts() {
		const response = await exportManagedSolutionsAccounts(accessToken, undefined, {purpose: "operational_account"})
		response.match(
			(d) => downloadFile("ManagedSolutionsOrgAccounts.csv", d, "text/csv"),
			() => addToast("Something went wrong", {appearance: "warning"})
		)
		return true
	}

	return (
		<>
			<TitleBar title={"Org Accounts"} />

			<MainSectionTable>
				<DataTableCard className={"managed-solutions-accounts-card"}>
					<DataTableActionHeader enableSticky={true} exportFunc={exportOrgAccounts} />
					<AsyncResultComponent asyncResult={result} pendingComponent={<TablePending numberOfRows={6} />}>
						{({value: accounts}) => {
							return (
								<ManagedSolutionsAccountsTable
									accounts={accounts.data}
									hasResults={hasResults}
									hasPrev={hasPrev}
									hasNext={hasNext}
									prev={prev}
									next={next}
									isUsingPaging={true}
									fullHeight={true}
									meta={accounts.meta}
									includedColumns={[
										ManagedSolutionsAccountsColumns.id,
										ManagedSolutionsAccountsColumns.userIds,
										ManagedSolutionsAccountsColumns.type,
										ManagedSolutionsAccountsColumns.createdAt,
										ManagedSolutionsAccountsColumns.status,
										ManagedSolutionsAccountsColumns.balance,
									]}
								/>
							)
						}}
					</AsyncResultComponent>
				</DataTableCard>
			</MainSectionTable>
		</>
	)
}
